export enum EBeneficiaryReportReported {
  PaymentRequestReported = "PAYMENT_REQUEST_REPORTED",
  PaymentRequestNotReported = "PAYMENT_REQUEST_NOT_REPORTED",
}

export enum EBeneficiaryReportReportingEnabledValues {
  ReportingEnabled = "REPORTING_ENABLED",
  ReportingDisabled = "REPORTING_DISABLED",
}
